import React, { Component } from 'react';
import Article from './ui/Article.js'
import Section from './ui/Section.js'

class ScalarValueType extends Component {
    render() {
        return (
            <Article kind="Scalar Value Type" title={this.props.descriptor.protoType} subtitle={this.props.descriptor.notes}>
                <Section title="Generated Types">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">Language</th>
                                <th scope="col">Native Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>C++</td><td>{this.props.descriptor.cppType}</td>
                            </tr>
                            <tr>
                                <td>C#</td><td>{this.props.descriptor.csType}</td>
                            </tr>
                            <tr>
                                <td>Go</td><td>{this.props.descriptor.goType}</td>
                            </tr>
                            <tr>
                                <td>Java</td><td>{this.props.descriptor.javaType}</td>
                            </tr>
                            <tr>
                                <td>PHP</td><td>{this.props.descriptor.phpType}</td>
                            </tr>
                            <tr>
                                <td>Python</td><td>{this.props.descriptor.pythonType}</td>
                            </tr>
                            <tr>
                                <td>Ruby</td><td>{this.props.descriptor.rubyType}</td>
                            </tr>
                            <tr>
                            </tr>
                        </tbody>
                    </table>
                </Section>
            </Article>
        );
    }
}

export default ScalarValueType;



// WEBPACK FOOTER //
// ./src/reference/ScalarValueType.js